import React from 'react';
import { useLang } from '../../LanguageContext';

// solData 의 카드 배열을 그리는 공용 컴포넌트
function Cards({ items, cols = 3, className = '', patch }) {
  const { lang } = useLang();
  const pick = (o) => (o ? o[lang] || o.ko : '');
  return (
    <div className={`sp-g${cols} ${className}`.trim()}>
      {items.map((c, i) => {
        const body = patch ? patch(pick(c.h), pick(c.p), lang) : pick(c.p);
        return (
          <div className="sp-card" key={i}>
            <h3>{pick(c.h)}</h3>
            {body && <p>{body}</p>}
            {c.feat && (
              <ul className="sp-feat">
                {c.feat.map((f, j) => <li key={j}>{pick(f)}</li>)}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Cards;
